import { render, staticRenderFns } from "./CategorizeJob.vue?vue&type=template&id=0e29d60e&"
import script from "./CategorizeJob.vue?vue&type=script&lang=ts&"
export * from "./CategorizeJob.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports